import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admission-cell-committee',
  templateUrl: './admission-cell-committee.component.html',
  styleUrls: ['./admission-cell-committee.component.scss']
})
export class AdmissionCellCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
